var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-editar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editar",
    clipPath: "url(#clip-editar)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2106",
    "data-name": "Grupo 2106",
    transform: "translate(-6.821 -9.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M0,0H118.283V118.284H0Z",
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_839",
    "data-name": "Trazado 839",
    d: "M23.828,14H18.552A10.549,10.549,0,0,0,8,24.552V72.034A10.549,10.549,0,0,0,18.552,82.586H66.036A10.549,10.549,0,0,0,76.588,72.034V66.759",
    transform: "translate(-3.054 12.259)",
    fill: "none",
    stroke: "#6a6a6a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_840",
    "data-name": "Trazado 840",
    d: "M78.067,24.914A11.08,11.08,0,0,0,62.4,9.245L18,53.483V69.31H33.828Z",
    transform: "translate(13.324 -0.845)",
    fill: "none",
    stroke: "#6a6a6a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.3c1e060ea6be4f4084774ff469c50063.svg";
export { ForwardRef as ReactComponent };